<template>
  <common-page-layout>
    <span slot="fixedtopbuttons">
      <back-button v-if="help" @click="openHelp(null)"/>
    </span>
    <span v-if="!help">
      <large-button-wide @click="openHelp('howtoorder')" >
        How to Create Remedial Request 
      </large-button-wide><br>
      <large-button-wide @click="openHelp('cart')" >
        Manage My Remedial
      </large-button-wide><br>
      <large-button-wide @click="openHelp('orders')" >
        Remedials
      </large-button-wide><br>
      <large-button-wide @click="openHelp('what_are_pwa')" >
        PWA
      </large-button-wide><br>
    </span>    
    <div v-if="help" v-html="help.htmlcontent"></div>    
  </common-page-layout>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {  
  name: "PWA",  
  data: function() {
    return {          
        help:null
    };
  },
  methods: {
     ...mapActions(["getHelpPage"]),
     openHelp(path){
        this.getHelpPage(path).then((content)=>{          
          this.help = content          
      })    
     }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/How.vue